import { render } from "./ResidentForm.vue?vue&type=template&id=eb581862&scoped=true"
import script from "./ResidentForm.vue?vue&type=script&lang=js"
export * from "./ResidentForm.vue?vue&type=script&lang=js"

import "./ResidentForm.vue?vue&type=style&index=0&id=eb581862&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb581862"]])

export default __exports__